<template>
    <div id="checklist">
        <h2>{{ 'Summary' | translate }}</h2>

        <ul class="checklist-items">
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.jmeno.valid, 'checklist-item-danger': !mazlicek.jmeno.valid, 'active-item': mazlicek.step.current === 1 }">
                <router-link :to="{ name: 'jmenomazlicka' }">
                    <div class="checklist-label">{{ 'Name of the pet' | translate }}</div>
                    <div class="checklist-value" v-if="mazlicek.jmeno.valid">{{ mazlicek.jmeno.value }}</div>
                    <div class="checklist-value" v-else>{{ 'Unfilled' | translate }}</div>
                </router-link>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.step.current >= 2, 'active-item': mazlicek.step.current === 2 }">
                <router-link v-if="mazlicek.step.current >= 2" :to="{ name: 'rasa' }">
                    <div class="checklist-label">{{ 'Breed' | translate }}</div>
                    <div class="checklist-value" v-if="mazlicek.rasa.typ === 'app_rasa'">
                        {{ mazlicek.rasa.autocomplete.keyword }}
                    </div>
                    <div class="checklist-value"
                         v-if="mazlicek.rasa.typ === 'app_velikost' && velikost && velikost.title">
                        {{ velikost.title }}
                    </div>
                    <div v-if="!mazlicek.rasa.typ && (mazlicek.rasa.typ === 'app_velikost' && velikost && velikost.title)" class="checklist-value">Nevyplněno</div>
                </router-link>
                <span v-else>
                    <div class="checklist-label">{{ 'Breed' | translate }}</div>
                    <div class="checklist-value" v-if="mazlicek.rasa.typ === 'app_rasa'">
                        {{ mazlicek.rasa.autocomplete.keyword }}
                    </div>
                    <div class="checklist-value"
                         v-if="mazlicek.rasa.typ === 'app_velikost' && velikost && velikost.title">
                        {{ velikost.title }}
                    </div>
                    <div v-if="!mazlicek.rasa.valid" class="checklist-value">
                        {{ 'Breed' | translate }}
                    </div>
                </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.fotografie.valid, 'checklist-item-danger': !mazlicek.fotografie.valid, 'active-item': mazlicek.step.current === 3 }">
                <router-link v-if="mazlicek.step.current >= 3" :to="{ name: 'fotografie' }">
                    <div class="checklist-label">{{ 'Photo' | translate }}</div>
                    <div v-if="mazlicek.fotografie.typ === 'foto' || mazlicek.fotografie.typ == 'ikona'">
                        <div class="checklist-value">{{ 'Yes' | translate }}</div>
                    </div>
                    <div class="checklist-value" v-if="!mazlicek.fotografie.valid">{{ 'Unfilled' | translate }}</div>
                </router-link>
                <span v-else>
                    <div class="checklist-label">{{ 'Photo' | translate }}</div>
                    <div v-if="mazlicek.fotografie.typ === 'foto' || mazlicek.fotografie.typ == 'ikona'">
                        <div class="checklist-value">Ano</div>
                    </div>
                    <div class="checklist-value" v-if="!mazlicek.fotografie.valid">{{ 'Yes' | translate }}</div>
                </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.narozeniny.valid, 'checklist-item-danger': !mazlicek.narozeniny.valid, 'active-item': mazlicek.step.current === 4 }">
                <router-link v-if="mazlicek.step.current >= 4" :to="{ name: 'narozeniny' }">
                    <div class="checklist-label">{{ 'Birthday' | translate }}</div>
                    <div class="checklist-value" v-if="mazlicek.narozeniny.valid">{{ formatDatumNarozeni }}</div>
                    <div class="checklist-value" v-else>{{ 'Unfilled' | translate }}</div>
                </router-link>
                <span v-else>
          <div class="checklist-label">{{ 'Birthday' | translate }}</div>
          <div class="checklist-value" v-if="mazlicek.narozeniny.valid">{{ formatDatumNarozeni }}</div>
          <div class="checklist-value" v-else>{{ 'Unfilled' | translate }}</div>
        </span>
            </li>
          <li class="checklist-item"
              v-bind:class="{ 'checklist-item-success': mazlicek.pohlavi.valid, 'checklist-item-danger': !mazlicek.pohlavi.valid, 'active-item': mazlicek.step.current === 5 }">
            <router-link v-if="mazlicek.step.current >= 5" :to="{ name: 'pohlavi' }">
              <div class="checklist-label">{{ 'Gender' | translate }}</div>
              <div class="checklist-value" v-if="mazlicek.pohlavi.valid && mazlicek.pohlavi.value === 'fena'">{{ 'Bitch' | translate }}
              </div>
              <div class="checklist-value" v-else-if="mazlicek.pohlavi.valid && mazlicek.pohlavi.value === 'pes'">{{ 'Dog' | translate }}
              </div>
              <div class="checklist-value" v-else>{{ 'Unfilled' | translate }}</div>
            </router-link>
            <span v-else>
              <div class="checklist-label">{{ 'Gender' | translate }}</div>
              <div class="checklist-value" v-if="mazlicek.pohlavi.valid && mazlicek.pohlavi.value === 'fena'">{{ 'Bitch' | translate }}</div>
              <div class="checklist-value" v-else-if="mazlicek.pohlavi.valid && mazlicek.pohlavi.value === 'pes'">{{ 'Dog' | translate }}</div>
              <div class="checklist-value" v-else>{{ 'Unfilled' | translate }}</div>
            </span>
          </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.hmotnostkondice.valid, 'checklist-item-danger': !mazlicek.hmotnostkondice.valid, 'active-item': mazlicek.step.current === 6 }">
                <router-link v-if="mazlicek.step.current >= 6" :to="{ name: 'hmotnostkondice' }">
                    <div class="checklist-label">{{ 'Weight and fitness' | translate }}</div>
                    <div class="checklist-value" v-if="mazlicek.hmotnostkondice.valid">
                        {{ kondiceValue }}
<!--                        <div class="hmotnost-kg"><span v-if="mazlicek.hmotnostkondice.kondice !== null"> , {{ kondicename.toLowerCase() }}</span>-->
<!--                        </div>-->
                    </div>
                 <!--   <div class="checklist-value" v-if="mazlicek.hmotnostkondice.valid"></div> -->
                    <div class="checklist-value" v-else>{{ 'Unfilled' | translate }}</div>
                </router-link>
                <span v-else>
                    <div class="checklist-label">{{ 'Weight and fitness' | translate }}</div>
                    <div class="checklist-value" v-if="mazlicek.hmotnostkondice.valid">
                        {{ kondiceValue }}
                    </div>
                <!--    <div class="checklist-value" v-if="mazlicek.hmotnostkondice.valid"></div> -->
                    <div class="checklist-value" v-else>{{ 'Unfilled' | translate }}</div>
                </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.pohyb.valid || mazlicek.jeStene, 'checklist-item-danger': !mazlicek.pohyb.valid && !mazlicek.jeStene, 'active-item': mazlicek.step.current === 7 }">
                <router-link v-if="mazlicek.step.current >= 7" :to="{ name: 'pohyb' }">
                    <div class="checklist-label">{{ 'Activity' | translate }}</div>
                    <div class="checklist-value">{{ aktivitaValue | translate }}</div>
                </router-link>
                <span v-else>
          <div class="checklist-label">{{ 'Activity' | translate }}</div>
            <div class="checklist-value">{{ aktivitaValue | translate }}</div>
        </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.alergie.valid, 'checklist-item-danger': !mazlicek.alergie.valid, 'active-item': mazlicek.step.current === 8 }">
                <router-link v-if="mazlicek.step.current >= 8" :to="{ name: 'alergie' }">
                    <div class="checklist-label">{{ 'Increased sensitivity' | translate }}</div>
                    <div class="checklist-value" v-if="mazlicek.alergie.valid"><span
                            v-if="mazlicek.alergie.alergie">{{ 'Yes' | translate }}</span><span v-else>{{ 'No' | translate }}</span></div>
                    <div class="checklist-value" v-else>{{ 'Unfilled' | translate }}</div>
                </router-link>
                <span v-else>
          <div class="checklist-label">{{ 'Increased sensitivity' | translate }}</div>
          <div class="checklist-value" v-if="mazlicek.alergie.valid"><span
                  v-if="mazlicek.alergie.alergie">{{ 'Yes' | translate }}</span><span v-else>{{ 'No' | translate }}</span></div>
          <div class="checklist-value" v-else>{{ 'Unfilled' | translate }}</div>
        </span>
            </li>
            <li class="checklist-item"
                v-bind:class="{ 'checklist-item-success': mazlicek.suroviny.valid, 'checklist-item-danger': !mazlicek.suroviny.valid, 'active-item': mazlicek.step.current === 9 }">
                <router-link v-if="mazlicek.step.current >= 9" :to="{ name: 'suroviny' }">
                    <div class="checklist-label">{{ 'Ingredients' | translate }}</div>
                    <div class="checklist-value" v-if="mazlicek.suroviny.valid">
                        <span v-if="mazlicek.suroviny.valid && slozkaItems && slozkaItems.length >= 2">
                            <span>{{ slozkaItems[0].title }}</span>,
                            <span>{{ slozkaItems[1].title }}</span>
                            <!--<span>{{ slozkaItems[2].title }}</span>-->
                        </span>
                    </div>
                    <div v-else class="checklist-value">{{ 'Unfilled' | translate }}</div>
                </router-link>
                <span v-else>
                    <div class="checklist-label">{{ 'Ingredients' | translate }}</div>
                    <div class="checklist-value" v-if="mazlicek.suroviny.valid">
                        <span v-if="mazlicek.suroviny.valid && slozkaItems && slozkaItems.length >= 2">
                            <span>{{ slozkaItems[0].title }}</span>,
                            <span>{{ slozkaItems[1].title }}</span>
                            <!--<span>{{ slozkaItems[2].title }}</span>-->
                        </span>
                    </div>
                    <div v-else class="checklist-value">{{ 'Unfilled' | translate }}</div>
                </span>
            </li>
            <!--<li class="checklist-item"-->
            <!--v-bind:class="{ 'checklist-item-success': mazlicek.hotovekrmivo.valid, 'checklist-item-danger': !mazlicek.hotovekrmivo.valid, 'active-item': mazlicek.step.current === 10 }">-->
            <!--<router-link v-if="mazlicek.step.current >= 10" :to="{ name: 'hotovekrmivo'}">-->
            <!--<div class="checklist-label">Hotové krmivo</div>-->
            <!--</router-link>-->
            <!--<span v-else>-->
            <!--<div class="checklist-label">Hotové krmivo</div>-->
            <!--</span>-->
            <!--</li>-->
        </ul>

        <!--ul class="checklist">
          <router-link v-for="item in items"
            :to="{ name:item.name }"
            :key="item.name"
            tag="li"
            v-bind:class="{ valid:isItemValid(item.name) }"
          >
            {{ item.label }}
          </router-link>
        </ul-->
        <div class="objednavka-btn" v-if="lastStep">
            <button class="button" @click="objednatBtn()">{{ 'Go to order' | translate }}</button>
         </div>
    </div>

</template>

<script>
    import moment from 'moment'
    import RightContentHeader from './RightContentHeader'
    import {apiSilex} from '../api'
    import filters from '../filters'
    import translateFilter from '../services/translator.js';

    export default {
        components: {
            'right-content-header': RightContentHeader
        },

        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                kondicename: '',
                aktivitaname: '',
                slozkaItems: [],
                velikost: null,
                items: [
                    {label: 'Jméno mazlíčka', name: 'jmenomazlicka', valid: false},
                    {label: 'Rasa', name: 'rasa', valid: false},
                    {label: 'Fotografie', name: 'fotografie', valid: false},
                    {label: 'Narozeniny', name: 'narozeniny', valid: false},
                    {label: 'Pohlaví', name: 'pohlavi', valid: false},
                    {label: 'Hmotnost a kondice', name: 'hmotnostkondice', valid: false},
                    {label: 'Pohyb', name: 'pohyb', valid: false},
                    {label: 'Alergie', name: 'alergie', valid: false},
                    {label: 'Suroviny', name: 'suroviny', valid: false},
                    {label: 'Hotové krmivo', name: 'hotovekrmivo', valid: false}
                ]
            }
        },
        computed: {
            formatDatumNarozeni: function () {
                return moment(this.mazlicek.narozeniny.value).format('D.M.Y')
            },
            imageSrc: function () {
                return 'https://dummyimage.com/200x200/000/fff&amp;text=ico'
            },
            lastStep: function() {
                // return $('li:last-child').hasClass('checklist-item-success');
                return this.mazlicek.step.current > 9;
            },
            hmotnostReadable: function () {
                return filters.round(this.mazlicek.hmotnostkondice.hmotnost) + 'kg / ' +
                    filters.round(this.mazlicek.hmotnostkondice.hmotnost * 2.20462262) + 'lb'
            },
            aktivitaValue: function () {
                if(this.mazlicek.jeStene
                    && this.mazlicek.pohyb.valid)
                    return this.translateFilter('Das not metr')
                else if (this.mazlicek.pohyb.valid) {
                    return this.translateFilter(this.aktivitaname)
                } else {
                    return this.translateFilter('Unfilled')
                }
            },
            kondiceValue: function () {
                var kondiceValue = this.hmotnostReadable

                if(this.mazlicek.hmotnostkondice.kondice !== null && !this.mazlicek.jeStene){
                    kondiceValue += ', ' + this.kondicename.toLowerCase()
                }

                return kondiceValue
            }
        },
        beforeUpdate: function () {


//            url = '/slozka'
//            apiSilex.get(url).then(function (response) {
//                response.data.forEach(function (entry) {
//                    if (!self.slozky[entry.id_typ_slozky]) self.slozky[entry.id_typ_slozky] = {suroviny: {}}
//
//                    self.slozky[entry.id_typ_slozky].suroviny[entry.id] = entry
//                })
//            })
        },
        methods: {
            isItemValid: function (val) {
                switch (val) {
                    case 'jmenomazlicka':
                        return this.mazlicek.jmeno.valid
                    case 'rasa':
                        return this.mazlicek.rasa.valid
                    case 'fotografie':
                        return this.mazlicek.fotografie.valid
                    case 'narozeniny':
                        return this.mazlicek.narozeniny.valid
                    case 'pohlavi':
                        return this.mazlicek.pohlavi.valid
                    case 'hmotnostkondice':
                        return this.mazlicek.hmotnostkondice.valid
                    case 'pohyb':
                        return this.mazlicek.pohyb.valid
                    case 'alergie':
                        return this.mazlicek.alergie.valid
                    case 'suroviny':
                        return this.mazlicek.suroviny.valid
                    case 'hotovekrmivo':
                        return this.mazlicek.hotovekrmivo.valid
                    default:
                        return false
                }
            },
            mountinMethod() {
                if(this.mazlicek.hmotnostkondice.kondice && this.kondicename === '') {
                    apiSilex.get('/hmotnost?id=' + this.mazlicek.hmotnostkondice.kondice).then(response => {
                        this.kondicename = response.data[0].title // this.$store.commit('setMazlicek', this.mazlicek)
                    })
                }
                if(this.mazlicek.pohyb.id && this.aktivitaname === '') {
                    apiSilex.get('/aktivita').then(response => {
                        this.aktivitaname = response.data.filter(
                            item => item.id === this.mazlicek.pohyb.id
                        )[0].title
                    })
                }
                if (this.mazlicek.suroviny.slozky[1] && this.slozkaItems.length === 0) {
                    let url = ''
                    url = 'slozka?id=' + this.mazlicek.suroviny.slozky['1']
                    apiSilex.get(url).then(
                        response => {
                            this.slozkaItems.push(response.data[0])
                        }
                    )
                    url = 'slozka?id=' + this.mazlicek.suroviny.slozky['2']
                    apiSilex.get(url).then(
                        response => {
                            this.slozkaItems.push(response.data[0])
                        }
                    )
                }

                if (this.velikost === null && this.mazlicek.rasa.velikost) {
                    apiSilex.get('/velikost?id=' + this.mazlicek.rasa.velikost).then(response => {
                        this.velikost = response.data[0]
                    })
                }
            },
                objednatBtn(){
                    this.$emit('activeTab',0);
                },
            translateFilter
        },
        mounted() {
            this.mountinMethod()
        },
        watch: {
            'mazlicek.productLoaded': {
                deep: true,
                handler: function (val) {
                    if (val)
                        this.mountinMethod()
                }
            },
            'mazlicek.petLoaded': {
                deep: true,
                handler: function (val) {
                    if (val)
                        this.mountinMethod()
                }
            },
            'mazlicek.step.current': {
                deep: true,
                handler: function (val) {
                    this.mountinMethod()
                }
            },
            'mazlicek.jeStene': {
                deep: true,
                handler: function (val) {
                    this.mountinMethod()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Checklist.vue?4eb81ab5